import { render, staticRenderFns } from "./automatic-item-lot-checkbox.vue?vue&type=template&id=3fac8c9c"
import script from "./automatic-item-lot-checkbox.vue?vue&type=script&lang=js"
export * from "./automatic-item-lot-checkbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports